import { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import RequiredInput from '../../../common/form/elements/required-input';

const model = 'game_levels';

class GameLevelFormColumn extends Component {
  render() {
    const { level } = this.props;

    return (
      <Col className="game-levels-box" md={3}>
        <Row>
          <Col md={12}>
            Game level {level}
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <RequiredInput
              label="Min. Number of Scans"
              model={`.${model}.level-${level}.minimum-number-of-scans.value`}
              type="number"
              min={0}
              step="any"
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <RequiredInput
              label="Prize amount points"
              model={`.${model}.level-${level}.prize-amount.value`}
              type="number"
              min={0}
              step="any"
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <RequiredInput
              label="Game link"
              model={`.${model}.level-${level}.cataboom-id.value`}
              type="text"
            />
          </Col>
        </Row>
      </Col>
    );
  }
}

export default GameLevelFormColumn;
